import { Link } from "react-router-dom";

const TopbarLoginWidget = () => {
    return (
        <li>
            <div className="v-align-middle">
                <Link to="/login"
                      className="button small rounded no-page-fade no-label-on-mobile no-margin-bottom"><span
                    className="icon-lock left"></span><span>로그인</span></Link>
            </div>
        </li>
    )
}

export default TopbarLoginWidget;